module.exports = __webpack_public_path__ + "img/9.1ebb5ae9.jpg";